import styled from 'styled-components'

export const MainWrapper = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

export const MainWrapperAttachment = styled.div`
  padding: 0px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

export const ModalHead = styled.div`
  padding: 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
`

export const ModalFooter = styled.div`
  margin-top: auto;
  padding: 0px 24px 24px 24px;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: end;
  align-content: center;
`

export const ModalFooterNoPadding = styled.div`
  margin-top: auto;
  padding: 0px;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: end;
  align-content: center;
`

export const LevelRowContainer = styled.div.attrs({
  className: `row col-12 mx-0`
})`
  border-top: ${({ borderNone, theme }) => borderNone ? 'none' : `1px solid ${theme.mocaLtGrey}`};
  padding: ${({ padding }) => padding ? padding : '24px 12px'};
`

export const ButtonAdd = styled.img`
  height: 40px;
  width: 40px;
  margin-bottom: 20px;

  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`

export const File = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 10px;
`

export const HeadContainer = styled.div`
  padding: 10px 0px;
  display: flex;
  flex-direction: row;
  align-content: center;
  border-bottom: 1px solid #e0e0e0;
`

export const InputCol = styled.div`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: column;
  margin-right: 5px;
  margin-left: 5px;
`

export const Title = styled.p`
  font-size: 18px;
  font-weight: bold;
  margin: 0;
`

export const RoundedWrapper = styled.div.attrs({
  className: 'col-12 mt-3',
})`
  flex: 1;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-right: ${({ gap }) => gap || 0};
`

export const ContainerButtonModal = styled.div`
  margin-top: 10px;
`

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const ContainerHeaderData = styled.div`
  margin-bottom: 20px;
  margin-top: 20px;
  border: 1px solid #000000;
  border-radius: 4px;
  padding: 10px;
`

export const FlexBetween = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;
`

export const Flex = styled.div`
  display: flex;
`

export const ContainerBodyTable = styled.div`
  height: 480px;
  overflow: auto;
  border: 1px solid #000000;
  border-radius: 4px;
  padding: 10px;
  font-size: 14px;
`

export const TextNew = styled.div`
  color: #32CD32
`

export const TextReupload = styled.div`
  color: #FF0000
`